import React, { useEffect, useState } from 'react'
import style from './addTips.module.scss'
import { TIPS } from '../Tips/tipsManagementConstant'
import Back from '../../../../shared/components/backButton/backButton'
import ImageUpload from '../../../../shared/components/imageUpload/imageUpload'
import Input from '../../../../shared/components/inputFields/input'
import Button from '../../../../shared/components/button/button'
import buttonStyle from '../../../../shared/components/button/button.module.scss'
import { Status } from '../../../../shared/globalConstants/constants'
import { addTipCreate } from '../../../../redux/FengShui/manageTips/manageTips.actions'
import useAxiosInstance from '../../../../hooks/useAxiosInstance'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAdminCategoryListing } from '../../../../redux/FengShui/adminCategory/adminCategory.actions'
import { selectAdminCategoryListingData } from '../../../../redux/FengShui/adminCategory/adminCategory.selectors'
import AWS from "aws-sdk"
import { isLoading } from '../../../../redux/progressLoader/progressLoader.actions'
import Toaster from '../../../../components/Global/Toaster/Toaster.component'
import { generateUUID } from '../../../../hooks/uniqueIdGenerator'
import { useNavigate } from 'react-router-dom'

const AddTips = () => {
  const axiosInstance = useAxiosInstance()
  const dispatch = useDispatch()
  const [toastList, setToastList] = useState([])
  const [formData, setFormData] = useState({})
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true)
  const [appId, setAppId] = useState('')
  const state = useSelector(state => state)
  const adminCategoryList = useSelector(selectAdminCategoryListingData)
  const navigate = useNavigate()
  const category = adminCategoryList?.listing?.listingData?.map(value => {
    return {
      value: value?._id,
      label: value?.categoryName
    }
  })
  const [mainImage, setMainImage] = useState("")
  const [subImages1, setSubImages1] = useState("")
  const [subImages2, setSubImages2] = useState("")
  const [subImages3, setSubImages3] = useState("")
  const [removeImage, setRemoveImage] = useState(false)
  const [removeImage1, setRemoveImage1] = useState(false)
  const [removeImage2, setRemoveImage2] = useState(false)
  const [removeImage3, setRemoveImage3] = useState(false)

  useEffect(() => {
    const selectedAppId = localStorage.getItem('appId')
    setAppId(selectedAppId)
  }, [appId])

  useEffect(() => {
    if(state?.getLanguages?.languageId) {
      const parms = {
        "languageId": state?.getLanguages?.languageId,
        "limit": 100000,
        "page": 1
      }
      dispatch(fetchAdminCategoryListing(axiosInstance, {}, parms))
    }
  }, [state?.getLanguages, dispatch, axiosInstance])

  const inputFields = [
    {
      type: "text",
      name: "Tip Name",
      label: 'Tip Name',
      required: false,
      width: '100%'
    },
    {
      type: "textarea",
      name: "Tip Content",
      label: "Tip Content",
      width: "100%",
    },
    {
      type: "dropdown",
      name: "Category",
      options: category,
      placeholder: 'Select Category',
      label: 'Category',
      width: '50%'
    },
    {
      type: "radio",
      name: "status",
      label: 'Status',
      options: Status,
      width: '100%'
    },
  ]

  const handleInputChange = (fieldName, fieldValue) => {
    setFormData({ ...formData, [fieldName]: fieldValue })
  }

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  })

  const myBucket = new AWS.S3({
    params: { Bucket: process.env.REACT_APP_AWS_BUCKET_NAME },
    region: process.env.REACT_APP_AWS_REGION,
  })

  const handleAdd = (imageUrl, img1, img2, img3) => {
    const userId = state?.user?.data?._id

    const tipDetails = {
      "languageId": state?.getLanguages?.languageId,
      "appId": localStorage.getItem("appId"),
      "categoryId": formData?.Category?.value,
      "title": formData['Tip Name'],
      "description": formData['Tip Content'],
      "imgPath": (imageUrl && !imageUrl?.includes('undefined')) ? imageUrl : formData.bookImage,
      "subImages": [img1 ? img1 : '', img2 ? img2 : '', img3 ? img3 : ''],
      "status": formData?.status,
      "featuredTip": false,
      "created_by": userId,
      "modified_by": userId,
    }
    dispatch(addTipCreate(axiosInstance, tipDetails, {}))
      .then((res) => {
        
        setRemoveImage(true)
        setRemoveImage1(true)
        setRemoveImage2(true)
        setRemoveImage3(true)
        setFormData({})
        setToastList([
          {
            id: 0,
            title: res.message,
            icon: "success",
          },
        ])
        setTimeout(() => {
          navigate(-1)
        }, 1500)
      })
      .catch((err) => {
        setToastList([
          {
            id: 0,
            title: err?.response?.data?.message,
            icon: "error",
          },
        ])
      })
  }


  const uploadToS3 = async (file, name) => {
    const id = generateUUID();
    const fileKey = `tip-main-${id}.${file?.type.split("/")[1]}`;
    const params = {
      Body: file,
      Bucket: process.env.REACT_APP_AWS_BUCKET_NAME,
      Key: fileKey,
    }
    try {
      dispatch(isLoading(true))
      const upload = await myBucket.upload(params).promise()
      if (upload) {
        dispatch(isLoading(false))
        return upload.Location
      }
    } catch (error) {
      setToastList([
        {
          id: 0,
          // title: "Error",
          title: "Error while uploading the Tip image.",
          icon: "error",
        }, 
      ]);
      dispatch(isLoading(false));
    }
  }

  const onCreate = (e) => {
    e.preventDefault()
    const fun = async () => {
      let img = ''
      let img1 = ''
      let img2 = ''
      let img3 = ''
      if(mainImage?.name) img = await uploadToS3(mainImage, mainImage.name)
      if(subImages1?.name) img1 = await uploadToS3(subImages1, subImages1.name)
      if(subImages2?.name) img2 = await uploadToS3(subImages2, subImages2.name)
      if(subImages3?.name) img3 = await uploadToS3(subImages3, subImages3.name)
      handleAdd(img, img1, img2, img3)
    }
    fun()
  }


  const handleFile = (url) => {
    if (url || url === "") {
      setMainImage(url)
    }
  }

  const handleSubFile1 = (url) => {
    if (url || url === "") {
      setSubImages1(url)
    }
  }
  const handleSubFile2 = (url) => {
    if (url || url === "") {
      setSubImages2(url)
    }
  }
  const handleSubFile3 = (url) => {
    if (url || url === "") {
      setSubImages3(url)
    }
  }

  useEffect(() => {
    if(formData?.["Tip Name"] !== "" 
        && formData?.["Tip Name"] !== undefined  
        && formData?.["Tip Content"] !== "" 
        && formData?.["Tip Content"] !== undefined 
        && formData?.["status"] !== "" 
        && formData?.["status"] !== undefined 
        && formData?.["Category"] !== ""
        && formData?.["Category"] !== undefined) {
            setIsSubmitDisabled(false)
        } else {
        setIsSubmitDisabled(true)
    }
}, [formData])


  return (
    <div className={style.container}>
      <div className={style.wrapper}>
        <div className={style.back}>
          <Back title={TIPS.ADD_TIPS.BACK.TITLE} description={TIPS.ADD_TIPS.BACK.DESCRIPTION} />
        </div>
        <div className={style.form_container} >
          <div className={style.upload}>
            <ImageUpload handleFile={handleFile} removeImage={removeImage} title={TIPS.ADD_TIPS.UPLOAD.TITLE} id={'mainimage1'} />
            <div className={style.smallUpload}>
              <ImageUpload removeImage={removeImage1} height={'64px'} width={'64px'} backgroundSize={'cover'} padding={'10px'} handleFile={handleSubFile1} id={'mainimage2'} />
              <ImageUpload removeImage={removeImage2} height={'64px'} width={'64px'} backgroundSize={'cover'} padding={'10px'} handleFile={handleSubFile2} id={'mainimage3'} />
              <ImageUpload removeImage={removeImage3} height={'64px'} width={'64px'} backgroundSize={'cover'} padding={'10px'} handleFile={handleSubFile3} id={'mainimage4'} />
            </div>
          </div>
          <form onSubmit={onCreate}>
            <div className={style.form_container}>
              {inputFields.map((inputField, index) => (
                <div key={index} className={style.input_field} style={{ width: inputField.width }}>
                  <Input
                    type={inputField.type}
                    name={inputField.name}
                    label={inputField.label}
                    value={formData[inputField.name]}
                    placeholder={inputField.placeholder}
                    options={inputField.options}
                    required={inputField.required}
                    onChange={(value) => handleInputChange(inputField.name, value)}
                    handleInputBlur={() => { }}
                  />
                  {/* <div className={style.error}>{formErrors[inputField.name]}</div> */}
                </div>
              ))}
              <div className={style.action_button}>
                <Button disabled={isSubmitDisabled} text={TIPS.ADD_TIPS.BUTTONS.TITLE} buttonType={isSubmitDisabled ? `${buttonStyle.button_disabled}` : `${buttonStyle.button_primary}`} />
              </div>
            </div>
          </form>
        </div>
      </div>
      <Toaster
        toastList={toastList}
        position={"top-right"}
        autoDelete={true}
        autoDeleteTime={2500}
      />
    </div>
  )
}

export default AddTips